import React, { ElementType } from 'react';
import {
  GroupBase,
  Select as ReactSelect,
  AsyncSelect as ReactAsyncSelect,
  CreatableSelect as ReactCreatableSelect,
  AsyncCreatableSelect as ReactAsyncCreatableSelect,
  ISelectOption,
  TSelectCommonProps,
  ISelectCustomProps,
} from '@dealroadshow/uikit-select';

import { IFinalFormFieldInputComponentProps } from '@framework/ui/Organisms/FinalForm/interfaces';

export type TSelectProps<
  SOption extends ISelectOption,
  IsMulti extends boolean,
  Group extends GroupBase<SOption>,
> = Omit<ISelectCustomProps<SOption, IsMulti>, keyof IFinalFormFieldInputComponentProps<SOption>['input']> &
  TSelectCommonProps<SOption, IsMulti, Group> &
  IFinalFormFieldInputComponentProps<SOption>;

const withFormInput = (SelectComponent: ElementType) => <
  SOption extends ISelectOption = ISelectOption,
  IsMulti extends boolean = boolean,
  Group extends GroupBase<SOption> = GroupBase<SOption>,
> ({ input, ...otherProps }: TSelectProps<SOption, IsMulti, Group>) => (
  <SelectComponent
    { ...otherProps }
    name={ input.name }
    value={ input.value }
    onBlur={ input.onBlur }
    onChange={ input.onChange }
  />
);

const Select = withFormInput(ReactSelect);
const AsyncSelect = withFormInput(ReactAsyncSelect);
const CreatableSelect = withFormInput(ReactCreatableSelect);
const AsyncCreatableSelect = withFormInput(ReactAsyncCreatableSelect);

export {
  Select,
  AsyncSelect,
  CreatableSelect,
  AsyncCreatableSelect,
};
